




























































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import LaporanSvc from "@/services/LaporanRekapSerahTerimaKantongDarah";
import {
  RekapSerahTerimaKantongFilter,
  RekapSerahTerimaKantongSummary,
  SerahTerimaKantongDarah
} from "@/types/serah_terima_kantong_darah";
import { composeDate, toDateString } from "@/utils/asesmenIntensifDateTime";

@Component({ components: { VCDateTimePicker } })
export default class LaporanRekapSerahTerimaKantongDarahPage extends Vue {
  filter: RekapSerahTerimaKantongFilter = {
    tgl_start: moment().startOf("month").format("YYYY-MM-DD"),
    tgl_end: moment().format("YYYY-MM-DD"),
    term: null
  };

  rows: SerahTerimaKantongDarah[] = [];
  summary: RekapSerahTerimaKantongSummary | null = null;
  maksBaris = 0;
  loading = false;
  downloading = false;

  readonly headers = [
    { text: "Tgl Crosstest", value: "tanggal_crosstest", width: "100px" },
    { text: "No Registrasi Sampel", value: "no_registrasi_sampel" },
    { text: "No Layanan", value: "no_layanan" },
    { text: "Pasien", value: "pasien", sortable: false },
    { text: "Bangsal", value: "bangsal" },
    { text: "Komponen / Golda", value: "darah", sortable: false },
    { text: "No Kantong", value: "nomor_kantong", sortable: false },
    { text: "Diambil", value: "diambil_at", width: "120px" },
    { text: "Petugas Bangsal / BDRS", value: "petugas", sortable: false },
    { text: "Keterangan", value: "keterangan", sortable: false }
  ];

  get tglStartDate(): Date | null {
    return composeDate(this.filter.tgl_start);
  }
  set tglStartDate(val: Date | null) {
    this.filter.tgl_start = toDateString(val) || this.filter.tgl_start;
  }

  get tglEndDate(): Date | null {
    return composeDate(this.filter.tgl_end);
  }
  set tglEndDate(val: Date | null) {
    this.filter.tgl_end = toDateString(val) || this.filter.tgl_end;
  }

  mounted() {
    this.load();
  }

  async load() {
    this.loading = true;
    try {
      const res = await LaporanSvc.list(this.filter);
      this.rows = res.rows || [];
      this.summary = res.summary;
      this.maksBaris = res.maks_baris;
    } catch {
      this.rows = [];
      this.summary = null;
    } finally {
      this.loading = false;
    }
  }

  async unduh() {
    this.downloading = true;
    try {
      await LaporanSvc.downloadExcel(this.filter).catch(() => undefined);
    } finally {
      this.downloading = false;
    }
  }

  tanggal(val: string | null): string {
    return val ? moment(val, "YYYY-MM-DD").format("DD-MM-YYYY") : "-";
  }

  waktu(val: string | null): string {
    return val ? moment(val, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY HH:mm") : "-";
  }
}
